// import Swiper from "swiper";
// import { Pagination, Autoplay, Navigation } from "swiper/modules";

// export default {
//    init() {

//       const blocks = document.querySelectorAll(".block-facilities-carousel");
//       if (!blocks.length) return;

//       blocks.forEach((block) => {
//          const panels = block.querySelectorAll(".facilities-panel");
//          if (!panels.length) return;

//          panels.forEach((panel) => {
//             const swiperEl = panel.querySelector(".swiper");
//             if (!swiperEl) return;

//             const speed = parseInt(swiperEl.dataset.speed) || 5000;

//             const nextEl = panel.querySelector(".swiper-button-next");
//             const prevEl = panel.querySelector(".swiper-button-prev");

//             new Swiper(swiperEl, {
//                modules: [Autoplay, Navigation, Pagination],
//                loop: false,
//                slidesPerView: 1,
//                spaceBetween: 24,
//                speed: 300,
//                autoplay: false,
//                navigation: {
//                   nextEl,
//                   prevEl,
//                },

//                breakpoints: {
//                   768: {
//                      slidesPerView: 2,
//                      spaceBetween: 32,
//                   },
//                   1024: {
//                      slidesPerView: 3,
//                      spaceBetween: 32,
//                   },
//                   1200: {
//                      slidesPerView: 4,
//                      spaceBetween: 40,
//                   },
//                },
//             });
//          });
//       });

//       blocks.forEach((block) => {
//          const tabs = block.querySelectorAll(".facilities-tab");
//          const panels = block.querySelectorAll(".facilities-panel");
//          const mobileLabel = block.querySelector(".facilities-tabs__mobile--label");
//          const dropdown = block.querySelector(".facilities-tabs__mobile--dropdown");
//          const items = block.querySelectorAll(".dropdown-li");

//          if (!tabs.length || !panels.length) return;

//          const setActive = (index) => {
//             tabs.forEach((tab, i) => {
//                tab.classList.toggle("active", i === index);
//             });

//             panels.forEach((panel, i) => {
//                panel.classList.toggle("active", i === index);
//             });
//          };

//          // default active tab
//          setActive(0);

//          // click event
//          tabs.forEach((tab) => {
//             tab.addEventListener("click", () => {
//                const index = parseInt(tab.dataset.tab, 10);
//                if (isNaN(index)) return;

//                setActive(index);
//             });
//          });

//          const isMobile = window.innerWidth < 768;
//          if (!isMobile) return;

//          mobileLabel.addEventListener("click", (e) => {
//             e.stopPropagation();
//             const isOpen = dropdown.classList.contains("is-open");

//             dropdown.classList.toggle("is-open", !isOpen);
//             mobileLabel.classList.toggle("is-open", !isOpen);
//          });

//          items.forEach((item) => {
//             item.addEventListener("click", () => {
//                const tabIndex = parseInt(item.dataset.tab, 10);

//                mobileLabel.childNodes[0].nodeValue = item.textContent;

//                dropdown.classList.remove("is-open");
//                mobileLabel.classList.remove("is-open");

//                const tabs = block.querySelectorAll(".facilities-tab");
//                const panels = block.querySelectorAll(".facilities-panel");

//                tabs.forEach((tab, i) => {
//                   tab.classList.toggle("active", i === tabIndex);
//                });

//                panels.forEach((panel, i) => {
//                   panel.classList.toggle("active", i === tabIndex);
//                });
//             });
//          });

//          document.addEventListener("click", () => {
//             dropdown.classList.remove("is-open");
//             mobileLabel.classList.remove("is-open");
//          });
//       });
//    }
// };

import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";

export default {
   init() {
      const blocks = document.querySelectorAll(".block-facilities-carousel");
      if (!blocks.length) return;

      blocks.forEach((block) => {
         const panels = Array.from(block.querySelectorAll(".facilities-panel"));
         const tabs = Array.from(block.querySelectorAll(".facilities-tab"));
         const nextEl = block.querySelector(".swiper-button-next");
         const prevEl = block.querySelector(".swiper-button-prev");

         if (!panels.length) return;

         let currentTabIndex = 0;
         let swiperInstances = [];

         // Initialize all swipers without default navigation
         panels.forEach((panel, i) => {
            const swiperEl = panel.querySelector(".swiper");
            if (!swiperEl) return;

            const swiper = new Swiper(swiperEl, {
               modules: [Autoplay, Navigation],
               loop: false,
               slidesPerView: 1,
               spaceBetween: 24,
               speed: 300,
               autoplay: false,
               breakpoints: {
                  768: { slidesPerView: 2, spaceBetween: 32 },
                  1024: { slidesPerView: 3, spaceBetween: 32 },
                  1200: { slidesPerView: 4, spaceBetween: 40 },
               },
            });

            swiperInstances[i] = swiper;
         });

         const setActiveTab = (index, resetSlide = true) => {
            currentTabIndex = index;

            tabs.forEach((tab, i) => tab.classList.toggle("active", i === index));
            panels.forEach((panel, i) => panel.classList.toggle("active", i === index));

            // Reset to first slide when switching tabs
            if (resetSlide && swiperInstances[index]) {
               swiperInstances[index].slideTo(0);
            }

            // Update mobile label
            const mobileLabel = block.querySelector(".facilities-tabs__mobile--label");
            if (mobileLabel && tabs[index]) {
               mobileLabel.childNodes[0].nodeValue = tabs[index].textContent;
            }
         };

         // Prev button: go to previous slide, or jump to last slide of previous tab
         prevEl?.addEventListener("click", () => {
            const swiper = swiperInstances[currentTabIndex];
            if (!swiper) return;

            if (swiper.isBeginning) {
               const prevTabIndex = (currentTabIndex - 1 + panels.length) % panels.length;

               setActiveTab(prevTabIndex, false);

               const prevSwiper = swiperInstances[prevTabIndex];
               if (prevSwiper) {
                  prevSwiper.slideTo(prevSwiper.slides.length - 1);
               }
            } else {
               swiper.slidePrev();
            }
         });

         // Next button: go to next slide, or jump to first slide of next tab
         nextEl?.addEventListener("click", () => {
            const swiper = swiperInstances[currentTabIndex];
            if (!swiper) return;

            if (swiper.isEnd) {
               const nextTabIndex = (currentTabIndex + 1) % panels.length;
               setActiveTab(nextTabIndex, true);
            } else {
               swiper.slideNext();
            }
         });

         // Tab click handler
         tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
               const index = parseInt(tab.dataset.tab, 10);
               if (!isNaN(index)) setActiveTab(index);
            });
         });

         // Set default active tab on init
         setActiveTab(0);

         // Mobile dropdown
         const mobileLabel = block.querySelector(".facilities-tabs__mobile--label");
         const dropdown = block.querySelector(".facilities-tabs__mobile--dropdown");
         const dropdownItems = block.querySelectorAll(".dropdown-li");

         mobileLabel?.addEventListener("click", (e) => {
            e.stopPropagation();
            dropdown?.classList.toggle("is-open");
            mobileLabel.classList.toggle("is-open");
         });

         dropdownItems.forEach((item) => {
            item.addEventListener("click", () => {
               const tabIndex = parseInt(item.dataset.tab, 10);
               if (!isNaN(tabIndex)) setActiveTab(tabIndex);
               dropdown?.classList.remove("is-open");
               mobileLabel?.classList.remove("is-open");
            });
         });

         // Close dropdown when clicking outside
         document.addEventListener("click", () => {
            dropdown?.classList.remove("is-open");
            mobileLabel?.classList.remove("is-open");
         });
      });
   }
};